import { render, staticRenderFns } from "./White.vue?vue&type=template&id=1ac6b433&"
import script from "./White.vue?vue&type=script&lang=js&"
export * from "./White.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ObjectsPublicTheExportNew: require('/web/components/objects/public/TheExportNew.vue').default,TheBlockHeader: require('/web/components/TheBlockHeader.vue').default})
